import React                  from 'react';

import { MenuDeclaration, MenuItems, MenuKeys, DividerText } from '../../constants/Menu';
import { DropdownBox }                          from '../../atoms/Dropdown/DropdownBox';
import { DropdownItem }                         from '../../atoms/Dropdown/DropdownItem';
import { LinkText }                             from './Navigation';
import styles from './Navigation.css';
import CustomLink from '../../atoms/RedirectLink/RedirectLink';

const DATA_ELEMENT_DESCRIPTION_SEARCH_TAG = 'search tag button';

type DesktopNavigationProps = {
    renderDivider: any,
    onClick: any;
};

export class DesktopNavigation extends React.Component<DesktopNavigationProps> {
    render = () => (
        <React.Fragment>
            {
                MenuItems.map((navItem, index) => (
                    <NavItem key = {navItem.key}>
                        {this.renderNavItem(navItem, index + 1)}
                    </NavItem>
                ))
            }

        </React.Fragment>
    )

    renderNavItem(nav: MenuDeclaration, index: number) {
        switch (nav.key) {
            case(MenuKeys.MORE): {
                return this.renderDropdown('More', nav.children, null, null);
            }
            default:
                return (
                    <CustomLink
                        data-element-description = {DATA_ELEMENT_DESCRIPTION_SEARCH_TAG}
                        key = {nav.key}
                        to = {`/category/${nav.key}`}
                        onClick = {() => this.props.onClick(nav.key, index)}
                        className={styles.desktopNavLink}
                    >
                        <LinkText size = "lg" color = "main">
                            {nav.title}
                        </LinkText>
                    </CustomLink>
                );
        }
    }

    renderDropdown(text, items: MenuDeclaration[], renderLastItem: () => JSX.Element, dividerItem: DividerText) {
        return (
            <DropdownBox buttonText = {text}>
                {
                    items.map((link, index) => (
                        <DropdownItem
                            data-element-description = {DATA_ELEMENT_DESCRIPTION_SEARCH_TAG}
                            key = {link.key}
                            title = {link.title}
                            link = {`/category/${link.key}`}
                            index = {index}
                            text = {`${link.key}__${text}`}
                            onClick = {this.props.onClick}
                        />
                    ))
                }
                {dividerItem ? this.props.renderDivider(dividerItem) : null}
                {renderLastItem ? renderLastItem() : null}
            </DropdownBox>
        );
    }
}
const NavItem = (props: any) => <div className = {styles.desktopNavItem} {...props} />;